'use client';
import { PageHero } from '@/components/general/PageHero';
import PageWrapper from '@/components/general/PageWrapper';
import ViewportWrapper from '@/components/structure/ViewportWrapper';
import React from 'react';
import ContactHero from './ContactHero';
import styles from './styles.module.css';
import ContactusInfo from './ContactusInfo';
import ContactusForm from './ContactusForm';

export default function ContactusContent() {
  return (
    <>
      <PageWrapper className={`p-0`}>
        <ViewportWrapper className={`w-full`}>
          <PageHero className={`${styles.heroContact}`}>
            <ContactHero />
          </PageHero>
        </ViewportWrapper>
      </PageWrapper>
      <PageWrapper className={`section-light pt-0 mt-0`}>
        <ViewportWrapper className={`container py-0`}>
          <div className={`${styles.sections}`}>
            <ContactusForm />
            <ContactusInfo />
          </div>
        </ViewportWrapper>
      </PageWrapper>
    </>
  );
}
